/**
 * پیامِ خطای خوانا از پاسخِ سرور.
 *
 * چرا: بیشتر جاهای برنامه `e.response.data.detail` را مستقیم به `message.error`
 * می‌دهند. ولی FastAPI برای خطای اعتبارسنجی (۴۲۲) `detail` را **آرایه** می‌دهد
 * و آن‌وقت یا چیزی نشان داده نمی‌شود یا رندر می‌شکند — کاربر فقط می‌بیند که
 * «هیچ اتفاقی نمی‌افتد». همین باعث شد آپلودِ بیمه بی‌صدا بچرخد.
 */

/** خطای هر شکلی → یک رشتهٔ فارسیِ قابلِ نمایش. */
export function apiError(e, fallback = "عملیات ناموفق بود") {
  const d = e?.response?.data?.detail ?? e?.response?.data;

  if (typeof d === "string" && d.trim()) return d;

  // ۴۲۲ پایدانتیک: [{loc:[...], msg:"...", type:"..."}]
  if (Array.isArray(d)) {
    const parts = d.map((x) => {
      if (typeof x === "string") return x;
      const where = Array.isArray(x?.loc) ? x.loc.filter(
        (p) => p !== "body" && p !== "query").join(" → ") : "";
      const msg = x?.msg || x?.type || "";
      return where ? `${where}: ${msg}` : msg;
    }).filter(Boolean);
    if (parts.length) return parts.join("؛ ");
  }

  // بعضی اندپوینت‌ها detail را دیکشنری می‌دهند (مثلِ قفلِ دوخت)
  if (d && typeof d === "object" && typeof d.message === "string") return d.message;

  // کدهای شناخته‌شده — پیش از هر تلاشی برای نمایشِ خامِ بدنه
  if (e?.response?.status === 413) return "حجمِ فایل بیش از حدِ مجاز است";
  if (e?.response?.status === 403) return "دسترسی لازم را ندارید";
  if (e?.message === "Network Error") return "ارتباط با سرور برقرار نشد";
  if (e?.code === "ECONNABORTED") return "زمانِ پاسخِ سرور تمام شد";

  // دیکشنریِ ناشناخته ولی **غیرِخالی** — بهتر از هیچ
  if (d && typeof d === "object" && Object.keys(d).length) {
    try { return JSON.stringify(d); } catch { /* حلقه‌دار */ }
  }
  return fallback;
}

export default apiError;
